<template>
    <div>
        <template v-if="field.range">
        </template>
        <template v-else>

        </template>
    </div>
</template>
<script>
export default {
    props:["field"],
    data(){
        return {

        }
    }
}
</script>